module.exports = __webpack_public_path__ + "static/media/edit_active.25d298a7.svg";